import { render, staticRenderFns } from "./starItem.vue?vue&type=template&id=aa881f5c&scoped=true"
import script from "./starItem.vue?vue&type=script&lang=js"
export * from "./starItem.vue?vue&type=script&lang=js"
import style0 from "./starItem.vue?vue&type=style&index=0&id=aa881f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa881f5c",
  null
  
)

export default component.exports